(function () {
	'use strict';

	angular
		.module('jcsfApp')
		.controller('nonpublicprojectsController', nonpublicprojectsController);

	nonpublicprojectsController.$inject = [
		'$controller',
		'$rootScope',
		'$scope',
		'$filter',
		'events',
		'authService',
	];

	function nonpublicprojectsController(
		$controller,
		$rootScope,
		$scope,
		$filter,
		events,
		authService
	) {
		$controller('baseController', { $scope: $scope });

		var vm = this;
		vm.projects = [];
		vm.centers = [];
		vm.errorMessage = '';
		vm.center = {};
		vm.userJCCCC = authService.authentication.userInfo.JCCCC;
		vm.centerId = authService.authentication.userInfo.JCCCC;
		vm.changeCenter = centerChanged;
		vm.orderBy =
			sessionStorage.getItem('nonPublicProjectsOrderBy') ||
			'PartnerOrganizationName';
		vm.orderByReverse = true;
		vm.setOrderBy = setOrderBy;
		vm.remove = deleteComponent;

		authService.fillAuthData();
		var authentication = authService.authentication;
		vm.saveCommProjectVerified = saveCommProjectVerified;

		activate();
		$scope.subscribe(
			events.message._GET_NON_PUBLIC_PROJECT_LIST_COMPLETE_,
			onGetProjectsComplete
		);
		$scope.subscribe(
			events.message._GET_NON_PUBLIC_PROJECT_LIST_FAILED,
			onGetProjectsFailed
		);
		$scope.subscribe(
			events.message._GET_JCCENTER_LIST_COMPLETE_,
			onGetJcCentersComplete
		);
		function activate() {
			if (authentication.userName == null || !authentication.isAuth) {
				$scope.$state.go('home');
			}
			$scope.publish(events.message._GET_JCCENTER_LIST_, []);
			//$scope.publish(events.message._GET_FOREST_LIST_,[]);
		}

		function saveCommProjectVerified(item) {
			if (item.ProjectId > 0) {
				item.LastModifiedBy = authentication.userName;
			}
			item.ProjectVerified = item.ProjectVerified;

			$scope.publish(events.message._SAVE_NON_PUBLIC_PROJECT_, [item]);
			//onGetProjectsComplete();
			activate();
		}

		function centerChanged(id) {
			vm.errorMessage = '';
			if (vm.hours) {
				vm.hours = [];
			}
			vm.projects = [];
			if (id) {
				$scope.publish(events.message._GET_NON_PUBLIC_PROJECT_LIST_, [
					true,
					id,
				]);
				vm.centerId = id;
				vm.center = $filter('filter')(vm.centers, { CenterId: vm.centerId })[0];
			} else {
				vm.center = {};
			}
		}
		function onGetProjectsComplete(results) {
			vm.projects = results;
		}
		function deleteComponent(part) {
			var confirmed = window.confirm(
				'Are you sure you want to delete ' + part.ProjectDescription + '?'
			);

			if (confirmed) {
				$scope.publish(events.message._DELETE_NON_PUBLIC_PROJECT_, [
					part.ProjectId,
				]);
			}
		}
		function onGetProjectsFailed(results) {
			vm.projects = [];
			if (!results || vm.projects.length === 0) {
				vm.errorMessage = 'No Records Returned';
			}
		}
		function onGetJcCentersComplete(results) {
			vm.centers = results;
			if (vm.userJCCCC !== 29) {
				vm.centerId = vm.userJCCCC;
			} else if (
				$rootScope.$stateParams.id !== null &&
				$rootScope.$stateParams.id !== undefined
			) {
				if (vm.userJCCCC !== 29) {
					vm.centerId = vm.userJCCCC;
				} else {
					vm.centerId = $rootScope.$stateParams.id;
				}
			}
			centerChanged(vm.centerId);
		}
		/**
		 * @param {string} column
		 */
		function setOrderBy(column) {
			vm.orderByReverse = vm.orderBy === column ? !vm.orderByReverse : false;
			vm.orderBy = column;
			sessionStorage.setItem('nonPublicProjectsOrderBy', column);
		}
	}
})();
